import { useEffect, useRef, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useApiClient } from '@/api/client'
import { useUser } from '@/auth/UserContext'
import type { WorkspaceSummary } from './WorkspaceContext'

export function RootRedirect() {
  const { user, isLoading } = useUser()
  const { fetchWithAuth } = useApiClient()
  const fetchRef = useRef(fetchWithAuth)
  const [target, setTarget] = useState<string | null>(null)

  useEffect(() => {
    fetchRef.current = fetchWithAuth
  }, [fetchWithAuth])

  useEffect(() => {
    let cancelled = false
    async function load() {
      if (!user) return
      const data = await fetchRef.current<{ items: WorkspaceSummary[] }>('/api/workspaces')
      if (cancelled) return
      if (data.items.length === 0) {
        setTarget('/onboarding')
        return
      }
      const last = window.localStorage.getItem('chrona:last-workspace-slug')
      const workspace = data.items.find((item) => item.slug === last) ?? data.items[0]
      setTarget(`/${workspace.slug}/home`)
    }
    load().catch(() => setTarget('/onboarding'))
    return () => {
      cancelled = true
    }
  }, [user])

  if (isLoading || !target) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Загрузка...
      </div>
    )
  }

  return <Navigate to={target} replace />
}
